$(document).ready(function(){
    validateForm({
        formId: 'form-person-individual'
        //formValidClass: 'Form_valid',
        //formInvalidClass: 'Form_invalid',
        //inputErrorClass: 'Input_error'
    });
});